var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotForProfitBuildings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 88,
    viewBox: "0 0 121 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.3334,
    width: 28,
    height: 2,
    fill: "#0F172A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 47.3334,
    width: 20,
    height: 2,
    fill: "#3D4353"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 84,
    transform: "translate(21.3334 2)",
    fill: "#3D4353"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.3334,
    y: 4,
    width: 22,
    height: 4,
    fill: "#0F172A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.3334,
    y: 10,
    width: 22,
    height: 4,
    fill: "#0F172A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 23.3334,
    y: 16,
    width: 22,
    height: 4,
    fill: "#0F172A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 23.3334,
    y: 22,
    width: 22,
    height: 4,
    fill: "#0F172A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 23.3334,
    y: 28,
    width: 22,
    height: 4,
    fill: "#0F172A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 23.3334,
    y: 34,
    width: 22,
    height: 4,
    fill: "#0F172A"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 23.3334,
    y: 40,
    width: 22,
    height: 4,
    fill: "#0F172A"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 23.3334,
    y: 46,
    width: 22,
    height: 4,
    fill: "#0F172A"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 23.3334,
    y: 52,
    width: 22,
    height: 4,
    fill: "#0F172A"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 23.3334,
    y: 58,
    width: 22,
    height: 4,
    fill: "#0F172A"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 23.3334,
    y: 64,
    width: 22,
    height: 4,
    fill: "#0F172A"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 23.3334,
    y: 70,
    width: 22,
    height: 4,
    fill: "#0F172A"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 29.3334,
    y: 76,
    width: 10,
    height: 8,
    fill: "#0F172A"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 84,
    transform: "translate(47.3334 2)",
    fill: "#6A6F7B"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 49.3334,
    y: 4,
    width: 14,
    height: 4,
    fill: "#3D4353"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 49.3334,
    y: 10,
    width: 14,
    height: 4,
    fill: "#3D4353"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 49.3334,
    y: 16,
    width: 14,
    height: 4,
    fill: "#3D4353"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 49.3334,
    y: 22,
    width: 14,
    height: 4,
    fill: "#3D4353"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 49.3334,
    y: 28,
    width: 14,
    height: 4,
    fill: "#3D4353"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 49.3334,
    y: 34,
    width: 14,
    height: 4,
    fill: "#3D4353"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 49.3334,
    y: 40,
    width: 14,
    height: 4,
    fill: "#3D4353"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 49.3334,
    y: 46,
    width: 14,
    height: 4,
    fill: "#3D4353"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 49.3334,
    y: 52,
    width: 14,
    height: 4,
    fill: "#3D4353"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 49.3334,
    y: 58,
    width: 14,
    height: 4,
    fill: "#3D4353"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 49.3334,
    y: 64,
    width: 14,
    height: 4,
    fill: "#3D4353"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 49.3334,
    y: 70,
    width: 14,
    height: 4,
    fill: "#3D4353"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 53.3334,
    y: 76,
    width: 6,
    height: 8,
    fill: "#3D4353"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 0.333374,
    y: 86,
    width: 120,
    height: 2,
    fill: "#C5C7CC"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 60.3334,
    y: 34,
    width: 22,
    height: 8,
    fill: "#F3F3F4"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 82.3334,
    y: 34,
    width: 14,
    height: 8,
    fill: "#C5C7CC"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 54.3334,
    y: 42,
    width: 28,
    height: 2,
    fill: "#C5C7CC"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 82.3334,
    y: 42,
    width: 20,
    height: 2,
    fill: "#989BA3"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 42,
    transform: "translate(56.3334 44)",
    fill: "#F3F3F4"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 58.3334,
    y: 46,
    width: 4,
    height: 8,
    fill: "#C5C7CC"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 64.3334,
    y: 46,
    width: 4,
    height: 8,
    fill: "#C5C7CC"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 70.3334,
    y: 46,
    width: 4,
    height: 8,
    fill: "#C5C7CC"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 76.3334,
    y: 46,
    width: 4,
    height: 8,
    fill: "#C5C7CC"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 58.3334,
    y: 56,
    width: 4,
    height: 8,
    fill: "#C5C7CC"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 64.3334,
    y: 56,
    width: 4,
    height: 8,
    fill: "#C5C7CC"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 70.3334,
    y: 56,
    width: 4,
    height: 8,
    fill: "#C5C7CC"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 76.3334,
    y: 56,
    width: 4,
    height: 8,
    fill: "#C5C7CC"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 58.3334,
    y: 66,
    width: 4,
    height: 8,
    fill: "#C5C7CC"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 64.3334,
    y: 66,
    width: 4,
    height: 8,
    fill: "#C5C7CC"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 70.3334,
    y: 66,
    width: 4,
    height: 8,
    fill: "#C5C7CC"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 76.3334,
    y: 66,
    width: 4,
    height: 8,
    fill: "#C5C7CC"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 64.3334,
    y: 76,
    width: 10,
    height: 8,
    fill: "#C5C7CC"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 42,
    transform: "translate(82.3334 44)",
    fill: "#C5C7CC"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 84.3334,
    y: 46,
    width: 2,
    height: 8,
    fill: "#989BA3"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 88.3334,
    y: 46,
    width: 2,
    height: 8,
    fill: "#989BA3"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 92.3334,
    y: 46,
    width: 2,
    height: 8,
    fill: "#989BA3"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 96.3334,
    y: 46,
    width: 2,
    height: 8,
    fill: "#989BA3"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 84.3334,
    y: 56,
    width: 2,
    height: 8,
    fill: "#989BA3"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 88.3334,
    y: 56,
    width: 2,
    height: 8,
    fill: "#989BA3"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 92.3334,
    y: 56,
    width: 2,
    height: 8,
    fill: "#989BA3"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 96.3334,
    y: 56,
    width: 2,
    height: 8,
    fill: "#989BA3"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 84.3334,
    y: 66,
    width: 2,
    height: 8,
    fill: "#989BA3"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 88.3334,
    y: 66,
    width: 2,
    height: 8,
    fill: "#989BA3"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 92.3334,
    y: 66,
    width: 2,
    height: 8,
    fill: "#989BA3"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 96.3334,
    y: 66,
    width: 2,
    height: 8,
    fill: "#989BA3"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 88.3334,
    y: 76,
    width: 6,
    height: 8,
    fill: "#989BA3"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 62.3334,
    y: 9,
    width: 32,
    height: 20,
    fill: "#F3F3F4"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 5,
    transform: "matrix(1 0 0 -1 66.3334 34)",
    fill: "#0F172A"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 5,
    transform: "matrix(1 0 0 -1 89.3334 34)",
    fill: "#0F172A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78.0001,
    cy: 19,
    r: 6,
    stroke: "#0F172A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.0001 13V25",
    stroke: "#0F172A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0001 19L74.0001 23",
    stroke: "#0F172A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0001 19L82.0001 23",
    stroke: "#0F172A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotForProfitBuildings);
export default __webpack_public_path__ + "static/media/NotForProfitBuildings.5f6f083e8175f8b3ff518954c654c921.svg";
export { ForwardRef as ReactComponent };